import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "VR楽器 \"isonote\""
const scope = "個人制作"
const str1 = "和音や音階などの音楽の構造を空間的・身体的・直感的に理解しながら、誰でも美しい演奏ができる「VR楽器」を構想、制作した。"
const str2 = "12平均律の各音を関係が深いものが近接するように均質に配置し、2本のバチで同時に最大6音を鳴らすことができるように打面を重ね合わせることで、さまざまな和音や音階の演奏を可能にした。スケールやモードといった音楽の概念を、距離やストロークといった空間・身体言語へと変換することができた。"
const str3 = <a href="https://note.com/banjo_kanna/n/na4b691aee49e" target="_blank" rel="noreferrer"><font color="#ff00ff">for more info.</font></a>

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.isonote01.childImageSharp.original.src}
          pageimgw={data.isonote01.childImageSharp.original.width}
          pageimgh={data.isonote01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
              <g id="レイヤー_2" data-name="レイヤー 2"><g id="UI"><path d="M98,50c-.61.38-1.28.06-6.25-2.49L50.65,26.42,91.74,5.29c5-2.56,5.78-2.95,6.3-2.52l.21.18a4.41,4.41,0,0,0,1.16-.62,6.42,6.42,0,0,1-.73-1.08A6,6,0,0,1,98.21,0,4.78,4.78,0,0,0,97,.58l0,.28c0,.68-.74,1.1-5.71,3.66L49.71,25.93,8.06,4.52C3.09,2,2.31,1.54,2.35.86l0-.28A4.78,4.78,0,0,0,1.2,0,6,6,0,0,1,.73,1.25,6.42,6.42,0,0,1,0,2.33,4.58,4.58,0,0,0,1.16,3l.22-.18c.51-.43,1.32,0,6.29,2.52L48.76,26.42,7.67,47.55C2.7,50.1,2,50.42,1.42,50l-.26-.16A4.44,4.44,0,0,0,0,50.5a6.11,6.11,0,0,1,.74,1.11,5.89,5.89,0,0,1,.46,1.22,4.45,4.45,0,0,0,1.18-.58l0-.3c.05-.72.69-1.08,5.66-3.64L49.71,26.9,91.35,48.31C96.32,50.87,97,51.23,97,52l0,.3a4.45,4.45,0,0,0,1.18.58,5.89,5.89,0,0,1,.46-1.22,6.11,6.11,0,0,1,.74-1.11,4.44,4.44,0,0,0-1.16-.62Z" fill="white"/></g></g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote03.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote04.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote05.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote06.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
            <p>{str3}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  isonote01: file(relativePath: {eq: "isonote01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
